module EnvironmentVariables {
    module.directive("uniqueKeyValidator", [function () {
        return {
            restrict: "A",
            require: "ngModel",
            scope: {
                uniqueKeyValidator: "<",
                originalKey: "<"
            },
            link: function (scope, element, attrs, ngModel) {
                ngModel.$validators.unique = function (value) {
                    if (!value) {
                        return true; // do not validate null or undefined, there are other validators for that
                    }
                    if (scope === null || scope.uniqueKeyValidator === null) {
                        // parent is null, this is possible when an
                        // array-parameter is not defined for a non-default environment -> it is empty and the value is unique
                        return true;
                    }
                    var blacklist = _.keys(scope.uniqueKeyValidator);
                    var valid = !_.some(blacklist, function (existingKey) { return existingKey.toLocaleLowerCase() === value.toLocaleLowerCase(); }) ||
                        value.toLocaleLowerCase() === (scope.originalKey && scope.originalKey.toLocaleLowerCase());
                    return valid;
                };
            }
        }
    }])
        .directive("restrictKeyWord", [function () {
            // list of c# keywords from https://msdn.microsoft.com/en-us/library/x53a06bb.aspx
            // these haven't changed since C# 1.0, only contextual keywords have been added
            var reservervedWords = ["abstract", "as", "base", "bool", "break", "byte", "case", "catch", "char", "checked", "class", "const", "continue", "decimal", "default", "delegate", "do", "double", "else", "enum", "event", "explicit", "extern", "false", "finally", "fixed", "float", "for", "foreach", "goto", "if", "implicit", "in", "int", "interface", "internal", "is", "lock", "long", "namespace", "new", "null", "object", "operator", "out", "override", "params", "private", "protected", "public", "readonly", "ref", "return", "sbyte", "sealed", "short", "sizeof", "stackalloc", "static", "string", "struct", "switch", "this", "throw", "true", "try", "typeof", "uint", "ulong", "unchecked", "unsafe", "ushort", "using", "virtual", "void", "volatile", "while"];
            return {
                restrict: "A",
                require: "ngModel",
                scope: false,
                link: function (scope, element, attr, ngModel) {
                    ngModel.$validators.keyWord = function (value) {
                        var valueMatchesKeyWord = _.some(reservervedWords, function (keyWord) { return value.toLowerCase() === keyWord.toLowerCase(); });
                        return !valueMatchesKeyWord;
                    }
                }
            }
        }])
        .directive("addItemForm", [function () {
            return {
                restrict: "E",
                templateUrl: "NewItemTemplate",
                scope: {
                    parent: "=",
                    topLevel: "=",
                    parentKey: "=",
                    addItemFn: "&"
                },
                controller: "NewItemController as newItemCtrl"
            };
        }])
        .directive("valueInputs", [function () {
            return {
                restrict: "E",
                templateUrl: "ValueInputsTemplate",
                replace: true,
                scope: {
                    key: "=",
                    val: "=",
                    valueType: "=",
                    parentKey: "=",
                    ctrl: "<"
                }
            };
        }])
        .directive("keyInput", [function () {
            return {
                restrict: "E",
                templateUrl: "KeyInputTemplate",
                replace: true,
                scope: {
                    key: "=",
                    newKey: "=",
                    parentKey: "=",
                    parentObject: "=",
                    isActive: "=",
                    searchText: "<",
                    defaultEnv: "<",
                    updateFn: "&"
                },
                controller: ["$scope", function ($scope) {
                    $scope.updateKey = function (key, newKey, input, parentKey) {
                        $scope.updateFn({ key: key, newKey: newKey, input: input, parentKey: parentKey });
                    };
                    $scope.resetValue = function (input: ng.INgModelController, key){
                        input.$setViewValue(key);
                        input.$render();
                        input.$setValidity("containsSecret", true);
                    }
                }]
            };
        }])
        .directive('ngConfirmClick', [
            function () {
                return {
                    priority: -1,
                    restrict: 'A',
                    scope: {
                        precondition: "=",
                        confirmMessage: "="
                    },
                    link: function (scope, element, attrs) {
                        element.bind('click', function (e) {
                            var message = scope.confirmMessage;
                            var preconditionMatches = scope.precondition === undefined || scope.precondition;

                            if (message && preconditionMatches && !confirm(message)) {
                                e.stopImmediatePropagation();
                                e.preventDefault();
                            }
                        });
                    }
                }
            }
        ]);
}